import { ContentfulClientApi, EntryCollection } from 'contentful';
import { CampaignFields } from '../campaigns/getCampaign';
import { Domain, Locale } from '../../types';

type BaseLandingPageFields = {
  domain: string;
  content: any;
};

type LandingPageFields = {
  domain: Domain;
  content: CampaignFields;
  footerPageLinks: any;
};

function serializeLandingPageResponse(data: EntryCollection<any>) {
  return {
    ...data.items[0].fields,
    content: data.items[0]?.fields.content?.fields,
    footerPageLinks: data.items[0].fields.footerPageLinks.map((entry: any) => ({
      id: entry.fields.id,
      label: entry.fields.header,
    })),
  };
}

export default async function getLandingPage(
  client: ContentfulClientApi,
  domain: Domain,
  locale: Locale = 'de'
): Promise<LandingPageFields> {
  try {
    const query = {
      locale,
      content_type: 'affiliateLandingPageConfig',
      ...(domain && { 'fields.domain': domain }),
      include: 1,
    };
    const res = await client.getEntries<BaseLandingPageFields>(query);
    return serializeLandingPageResponse(res);
  } catch (error) {
    console.error('Contentful Error:: getLandingPage failed');
    throw error;
  }
}
